export default __webpack_public_path__ + "static/media/think.0164ea7c.jpg";